import React, {Component} from 'react';
import { injectIntl } from 'react-intl';
import TransitionLink from 'components/transition-link/transition-link';
import Button from 'components/button/button';
import MakeHash from 'make-hash';
import Hero from 'components/heroes/hero';
import Page from 'components/page/page';
import messages from './messages';

class Landing extends Component {
  constructor(props) {
    super(props);

    const { intl } = props;

    this.page = {
      'heading': intl.formatMessage(messages.heading),
      'intro': intl.formatMessage(messages.intro),
      'actions': [
        {
          'path': '/sign-in',
          'label': intl.formatMessage(messages.sign_in_label)
        }
      ]
    };
  }

  _renderHero() {
    return (
      <Hero
        type="full"
        title={this.page.heading}
        supportingTxt={this.page.intro}
        actionsLayout="row"
      >
        {this.page.actions.map((action, i) => {
          return(
            <div className="hero-action" key={MakeHash(`${action.label}-${i}`)}>
              <TransitionLink
                animateOnClick
                className="btn btn_dark btn_fixedWidth"
                to={action.path}
              >
                {action.label}
              </TransitionLink>
            </div>
          );
        })}
      </Hero>
    )
  }

  render() {
    const pageHero = this._renderHero();
    return (
      <Page fullTexture title={this.page.heading} pageHero={pageHero} />
    );
  }
}

export default injectIntl(Landing);



// WEBPACK FOOTER //
// ./src/client/pages/landing/landing.jsx